export const vacaciones_programadas_fields = [
    {
        key: "empleado",
        label: "Employee",
        visible: true,
    },
    {
        key: "fechas",
        label: "Fechas",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
];

export const vacaciones_por_programar_fields = [
    {
        key: "id",
        label: "Fecha",
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "comprar",
        label: "Comprar",
        thClass: "text-center",
        tdClass: "text-center",
    },
];

export const vacaciones_reprogramar_fields = [
    {
        key: "fecha",
        label: "Fecha",
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "anio_periodo",
        label: "Periodo",
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "comprado",
        label: "Vacacion Comprada",
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "costo",
        label: "Costo",
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "created_at",
        label: "Fecha de registro",
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        key: "actions",
        label: "Acciones",
        thClass: "text-center",
        tdClass: "text-center",
    },
];

export const vacaciones_por_pagar_fields = [
    {
        key: 'selected',
        label: '',
        thStyle: { width: '50px' },
        visible: true,
    },
    {
        key: "anio_periodo",
        label: "Periodo",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        key: "fecha",
        label: "Fecha",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        key: "fecha_pago",
        label: "Fecha de pago",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        key: "costo",
        label: "Costo",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        key: "created_at",
        label: "Fecha de registro",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
];

export const vacaciones_calendario_fields = [
    { key: 'empleado', label: 'Empleado', thClass: 'text-left', tdClass: 'text-left' },
    { key: 'mes_1', label: 'Enero', thClass: 'text-center', tdClass: 'text-center' },
    { key: 'mes_2', label: 'Febrero', thClass: 'text-center', tdClass: 'text-center' },
    { key: 'mes_3', label: 'Marzo', thClass: 'text-center', tdClass: 'text-center' },
    { key: 'mes_4', label: 'Abril', thClass: 'text-center', tdClass: 'text-center' },
    { key: 'mes_5', label: 'Mayo', thClass: 'text-center', tdClass: 'text-center' },
    { key: 'mes_6', label: 'Junio', thClass: 'text-center', tdClass: 'text-center' },
    { key: 'mes_7', label: 'Julio', thClass: 'text-center', tdClass: 'text-center' },
    { key: 'mes_8', label: 'Agosto', thClass: 'text-center', tdClass: 'text-center' },
    { key: 'mes_9', label: 'Septiembre', thClass: 'text-center', tdClass: 'text-center' },
    { key: 'mes_10', label: 'Octubre', thClass: 'text-center', tdClass: 'text-center' },
    { key: 'mes_11', label: 'Noviembre', thClass: 'text-center', tdClass: 'text-center' },
    { key: 'mes_12', label: 'Diciembre', thClass: 'text-center', tdClass: 'text-center' },
];
